<template>
	<ItemNotFoundState v-if="objectNotFound" :objectName="'Prohlídka'">
		<template #backButton>
      <BackButton :explicit-push="true" :target="{name: 'OnboardingMaster', query: { tab: 'scenarios'}}">Prohlídky</BackButton>
		</template>
	</ItemNotFoundState>
	<Loading v-else-if="!didLoadData || !scenario"/>
	<div v-else>
    <BackButton :explicit-push="true" :target="{name: 'OnboardingMaster', query: { tab: 'scenarios'}}">Prohlídky</BackButton>
		<ModuleHeader id="header">
			<h2 v-if="isNew">Nová prohlídka</h2>
			<h2 v-else>Úprava prohlídky</h2>
			<v-spacer/>
			<SaveButton
				:is-saving="isSaving"
				:disabled="!isFormValid"
				@save="save()"
				label="Uložit" />
		</ModuleHeader>
		<v-alert v-if="!isFormValid" type="warning" max-width="600px" class="mt-4 mb-0">Pro přidání prohlídky je potřebný název v obou jazycích a přidání alespoň jedné lokace</v-alert>

		<v-form @submit.prevent="save" ref="form" :value="isFormValid">
			<div class="language-selector mb-5">

				<div class="d-flex align-center">
					<v-tabs
						v-model="currentLanguage"
						color="light-green darken-1 pull-right"
					>
						<v-tab id="cz" class="small" :key="languages[0].value">
							<div class="d-flex align-center">
								<p class="mb-0 ml-2">{{this.languages[0].text}}</p>
							</div>

						</v-tab>

						<v-tab id="en" class="small" :key="languages[1].value">
							<div class="d-flex align-center">
								<p class="mb-0 ml-2">{{this.languages[1].text}}</p>
							</div>
						</v-tab>
					</v-tabs>

					<v-tabs-items v-model="currentLanguage">
						<v-tab-item
							:value="languages[0].value"
						></v-tab-item>
						<v-tab-item
							:value="languages[1].value"
						></v-tab-item>
					</v-tabs-items>

				</div>
			</div>
			<v-layout>
				<v-row>
					<v-col cols="12">
						<h4 class="mb-3 title">O prohlídce</h4>
						<v-row>
							<v-col cols="12" :md="isNew ? 12 : 8">
								<v-row>
									<v-col v-if="scenario" cols="12">
										<v-text-field
											id="scenario-name"
											label="Název prohlídky"
											:rules="[required_rule]"
											v-model="scenario.localizedAttributes[currentTabLanguage].name"
											:rows="1"
											:maxlength="50"
											counter
											auto-grow
											color="light-green darken-1"
                                            variant="underlined"
										></v-text-field>
									</v-col>
								</v-row>
								<v-row>
									<v-col v-if="scenario" cols="12">
										<v-text-field
											label="Krátký popis"
											v-model="scenario.localizedAttributes[currentTabLanguage].description"
											:maxlength="150"
											counter
											auto-grow
											:rows="1"
											color="light-green darken-1"
                                            variant="underlined"
										></v-text-field>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="12" :md="isNew ? 0 : 4">
								<div  v-if="!isNew">
                  <file-manager
                      v-if="!isNew"
                      ref="imagesManager"
                      :allowed-file-types="dropzoneImageOptions.allowedFileTypes"
                      :minimum-height="dropzoneImageOptions.minimumHeight"
                      :minimum-width="dropzoneImageOptions.minimumWidth"
                      :multiple="true"
                      @update:files="files => setScenarioImages(files)"
                      preview="gallery"
                      :files="getScenarioImages"
                      :upload-url="`onboarding/scenarios/images/${scenario.id}`"
                      :file-url="file => `onboarding/scenarios/images/${scenario.id}/${file.id}`"
                      :delete-url="file => `onboarding/scenarios/images/${scenario.id}/${file.id}`"
                  >
                  </file-manager>
								</div>
							</v-col>
							<v-col cols="12">
								<h4 class="mb-3 title">Lokace</h4>
								<v-row>
									<v-col cols="12" md="6">
										<span class="mb-3 label">Dostupné lokace</span>
										<v-text-field
											v-model="search"
											prepend-icon="search"
											label="Hledat"
											single-line
											hide-details
											color="light-green darken-1"
                                            variant="underlined"
										></v-text-field>
										<v-data-table
											:headers="locationHeaders"
                      :hover="true"
											:items="getLocations"
											:search="search"
											class="elevation-2 location-table">
											<template v-slot:item.id="{ item }">
												<v-icon class="addLocation" color="primary" @click="addLocation(item)">add_circle</v-icon>
											</template>
										</v-data-table>
									</v-col>
									<v-col cols="12" md="6">
										<span class="mb-3 label">Vybrané lokace</span>
										<draggable
											id="selectedLocations"
											:list="iterableLocations"
											:disabled="false"
											class="list-group">
											<template class="list-group-item" v-for="item in iterableLocations" :key="item.id">
                                                <v-row class="mr-2 draggable-list-item">
                                                    <v-col cols="1">
                                                        <v-icon class="text-grey-darken-2">drag_handle</v-icon>
                                                    </v-col>
                                                    <v-col cols="9">
                                                        <div>{{item.localizedAttributes[currentTabLanguage].name}}</div>
                                                    </v-col>
                                                    <v-col cols="2">
                                                        <v-icon class="removeLocation" color="red" @click="removeLocation(item)">clear</v-icon>
                                                    </v-col>
                                                </v-row>
											</template>
										</draggable>
<!--                                        <div class="flex m-10">-->
<!--                                            <draggable class="dragArea list-group w-full" :list="iterableLocations" @change="log">-->
<!--                                                <div-->
<!--                                                    class="list-group-item bg-gray-300 m-1 p-3 rounded-md text-center"-->
<!--                                                    v-for="element in iterableLocations"-->
<!--                                                    :key="element.name"-->
<!--                                                >-->
<!--                                                    {{ element.name }}-->
<!--                                                </div>-->
<!--                                            </draggable>-->
<!--                                        </div>-->
									</v-col>
								</v-row>
								<v-btn id="deleteScenario" class="no-padding-btn" v-if="!isNew" color="red" variant="text" @click="attemptDeleteScenario">Smazat prohlídku</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-dialog v-model="deleteScenarioDialog" max-width="500px">
					<v-card>
						<v-card-title><h5 class="text-h5 ma-auto">Opravdu chcete smazat tuto prohlídku?</h5></v-card-title>
						<v-card-actions>
							<v-spacer/>
							<v-btn color="blue darken-1" variant="text" @click="deleteCancel">Zrušit</v-btn>
							<v-spacer/>
							<v-btn id="deleteConfirm" color="red darken-1" variant="text" @click="deleteConfirm">Potvrdit</v-btn>
							<v-spacer/>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-layout>
		</v-form>
	</div>
</template>

<script>

import {mapGetters, mapActions, mapMutations} from 'vuex';
	import ModuleHeader from "@/components/layout/ModuleHeader";
	import BackButton from "@/components/layout/BackButton";
	import SaveButton from "@/components/buttons/SaveButton";
	import {getLocalizedLanguages} from "@/localization/languages";
	import ItemNotFoundState from '@/components/states/ItemNotFoundState.vue';
	import Loading from "@/components/Loading";
    import Draggable from "vue3-draggable";
    import { VueDraggableNext } from 'vue-draggable-next'
	import {config} from "@/config";
import FileManager from "@/components/files/FileManager.vue";

	export default {
		name: "ScenarioDetail",

		components: {
      FileManager,
			SaveButton,
			BackButton,
			ModuleHeader,
			ItemNotFoundState,
			Loading,
			Draggable,
            draggable: VueDraggableNext,
		},

		data(){
			return {
				required_rule: value => (value !== "") || 'Povinné',
				isSaving: false,
				currentLanguage: "cz",
                currentTabLanguage: "cz",
				search: "",
				type: null,
				locationHeaders: [
					{
						title: '',
						key: 'id',
						width: '15%'
					},
					{
						title: 'Název',
						key: 'localizedAttributes.cz.name',
						width: "50%"
					},
					{
						title: 'Typ lokace',
						key: 'locationType.name',
						width: "35%"
					},
				],
				ownLocationHeaders: [
					{
						title: 'poradi',
						value: 'order',
						width: '15%'
					},
					{
						title: 'Název',
						value: 'localizedAttributes.cz.name',
						width: "70%"
					},
					{
						title: 'akce',
						value: 'action',
						width: "15%"
					},
				],
				carouselActiveImage: 0,
				dropzoneImageOptions: {
          allowedFileTypes: ['image/jpeg', 'image/png','image/jpg'],
          minimumHeight: 1000,
          minimumWidth: 1000
				},
				iterableLocations: [],
				deleteScenarioDialog: false,
			}
		},

		mounted() {
			this.loadData();
		},
    beforeUnmount() {
      this.clearScenario()
    },

		watch: {
			scenarioId() {
				this.loadData();
			},

            currentLanguage(curr) {
                if (curr) this.currentTabLanguage = "en"
                else this.currentTabLanguage = "cz"
            }
		},

		computed: {
			...mapGetters('Scenarios', ['scenarioById', 'getScenario','newScenario', 'emptyScenario', 'didLoadScenario', 'getScenarioImages']),
			...mapGetters('Locations', ['locations', 'didLoadLocations']),
			...mapGetters('errors', ['objectNotFound']),


			/**
			 * Returns array of unselected locations.
			 * @returns {*[]}
			 */
			getLocations(){
				const alreadyUsed = [];
				this.iterableLocations.forEach((location) => {
					alreadyUsed.push(location.id);
				});

				return this.locations.filter((l) => !alreadyUsed.includes(l.id))
			},
			isNew() { return this.scenarioId === null; },

			didLoadData() {
				return (this.didLoadScenario || this.isNew) && this.didLoadLocations
			},

			scenarioId() {
				const urlId = this.$route.params.id;
				return urlId === "new" ? null : Number(urlId);
			},

			scenario(){
        if (this.isNew){
          return this.newScenario
        } else {
          return this.getScenario
        }
			},

			languages() {
				const langs = getLocalizedLanguages();
				const selectArr = [];
				Object.keys(langs).map((lng) => {
					selectArr.push({
						'text': langs[lng],
						'value': lng,
					});
				});
				return selectArr;
			},

			/**
			 * Form validation methods.
			 * @returns {boolean}
			 */
			isFormValid() {
				return (
					this.hasAllRequiredFields && this.hasAtLeastOneLocation
				);
			},
			hasAllRequiredFields() {
				return this.scenario.localizedAttributes[this.languages[0].value].name !== ""
					&& this.scenario.localizedAttributes[this.languages[1].value].name !== "";
			},
			hasAtLeastOneLocation() {
				return this.iterableLocations.length > 0;
			}
		},

		methods: {
      ...mapActions('leavePrevent',['didSaveChanges']),
			...mapActions('Scenarios', ['fetchScenarioById', 'createScenario', 'updateScenario', 'deleteScenario', 'clearScenario', 'fetchImages']),
			...mapActions('Locations', ['fetchLocations']),
			...mapActions('errors', ['clear']),
      ...mapMutations('Scenarios',['setImages']),


			/**
			 * Loads actual data from server or prepares a blank scenario.
			 * @returns {Promise<void>}
			 */
			async loadData(){
				await this.fetchLocations()
				if ( !this.isNew ) {
					await this.fetchScenarioById(this.scenarioId)
						.then(() => {
							this.getIterableLocations();
						})
				}
				else {
					this.clear();
					this.getIterableLocations();
				}

			},

			/**
			 * Attempts to save or update a scenario.
			 * @returns {Promise<void>}
			 */
			async save(){
				if (this.$refs.form.validate()) {
					this.isSaving = true;

					let scenarioRequest = {
						'localizedAttributes': this.scenario.localizedAttributes,
						'locations': {}
					}

					this.iterableLocations.forEach((l, i) => {
						scenarioRequest.locations[i] = l.id;
					});

					if ( this.isNew ){
						await this.createScenario({scenario: scenarioRequest});
            await this.$router.push({name: 'OnboardingMaster', query: {tab: 'scenarios'}})
					}
					else {
						scenarioRequest['id'] = this.scenarioId;
						await this.updateScenario({scenario: scenarioRequest})
            await this.$refs.imagesManager.upload();
            this.isSaving = false
					}
				}
			},

      setScenarioImages(images) {
        this.setImages(images)
      },
			/**
			 * Helper method to get the URL of an image.
			 * @param id
			 * @returns {string}
			 */
			getImageUrl(id){
				return config.serverUrl+"onboarding/scenarios/images/"+this.scenario.id+"/"+ id;
			},

			/**
			 * Helper method that opens an image in a new window.
			 * @param src
			 */
			redirect(src){
				window.open(src, '_blank');
			},

			/**
			 * Helper method that adds a location to scenario.
			 * @param location
			 */
			addLocation(location){
				this.iterableLocations.push(location);
			},

			/**
			 * Helper method that removes a location from scenario.
			 * @param position
			 */
            removeLocation(item) {
                const index = this.iterableLocations.findIndex(location => location.id === item.id);
                if (index !== -1) {
                    this.iterableLocations.splice(index, 1);
                }
            },

			/**
			 * Helper method that attempts to delete a scenario.
			 */
			attemptDeleteScenario(){
				this.deleteScenarioDialog = true;
			},

			/**
			 * Helper method that proceeds with scenario deletion.
			 */
			async deleteConfirm(){
				this.deleteScenario(this.scenario.id).then(() => {
					this.deleteScenarioDialog = false;
          this.$router.push({name: 'OnboardingMaster', query: { tab: 'scenarios'}});
				})
			},
			/**
			 * Helper method that cancels scenario deletion.
			 */
			deleteCancel(){
				this.deleteScenarioDialog = false;
			},

			/**
			 * Helper method that transforms an incoming ordered locations dictionary into an iterable list of locations.
			 */
			getIterableLocations() {
				let arr = [];
				if ( this.scenario === null ) return arr;
				for ( let key in this.scenario.locations ){
					arr.push( {
						...this.scenario.locations[key],
						order: key }
					);
				}
				this.iterableLocations = arr;
			},
		}
	}
</script>

<style scoped>
	.location-table {
    margin-left: 0.1em;
		margin-top: 2em;
    margin-bottom: 2em;
	}
	.notice {
		max-width: 250px;
	}
	.list-group {
		display: -ms-flexbox;
		display: -webkit-box;
		display: flex;
		-ms-flex-direction: column;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		flex-direction: column;
		padding-left: 0.8em;
    padding-top: 0;
		margin-bottom: 0;
	}
  .draggable-list-item {
    margin-top: 11px;
    border: 1px solid #e4e4e4;
  }
	.list-group-item {
		cursor: move;
		position: relative;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		padding: 1.25rem;
		margin-bottom: -1px;
		background-color: #fff;
		border: 1px solid rgba(0,0,0,.125);
	}
	.list-group-item:first-child {
		border-top-left-radius: 0.25rem;
		border-top-right-radius: 0.25rem;
	}
	.list-group-item:last-child {
		margin-bottom: 0;
		border-bottom-right-radius: 0.25rem;
		border-bottom-left-radius: 0.25rem;
	}
	.ghost {
		cursor: move;
		opacity: 0.5;
		background: #c8ebfb;
	}
	.label {
		color: rgba(0,0,0,0.6) !important;
		line-height: 50px;
	}
	.no-padding-btn {
		padding: 0 !important;
	}
</style>
